import { SVGProps } from 'react'

export const Checkmark = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" fill="none" viewBox="0 0 17 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.539 7.528a.67.67 0 01.945 0l2.674 2.667a.665.665 0 010 .943.67.67 0 01-.945 0L3.539 8.47a.665.665 0 010-.943z"
      clipRule="evenodd"
    ></path>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.506 4.862a.665.665 0 010 .943l-5.348 5.333a.67.67 0 01-.946 0 .665.665 0 010-.942l5.349-5.334a.67.67 0 01.945 0z"
      clipRule="evenodd"
    ></path>
  </svg>
)
